<template>
  <form class="flex items-center gap-2">
    <IconLanguage class="inline-block text-gray-200" />
    <!-- <span class="max-md:hidden text-white">Language: </span> -->
    <select
      v-model="$i18n.locale"
      class="rounded-lg bg-gray-100 bg-opacity-20 bg-none px-3 py-2 text-sm text-gray-200 transition duration-100 hover:bg-opacity-30"
      @change="handleLocaleChange">
      <option value="en">EN</option>
      <option value="si">SI</option>
    </select>
  </form>
</template>

<script setup lang="ts">
  import { EventName, PropName } from '~/constants/plausible'

  const { trackEvent } = usePlausible()

  function handleLocaleChange(event: Event) {
    trackEvent(EventName.SET_LOCALE, {
      props: { [PropName.LOCALE]: (event.target as HTMLSelectElement).value }
    })
  }
</script>
